export default {
  title: 'Información médica',
  titleDescription: 'Complete la siguiente información para poder continuar',
  nameLabel: 'Nombre y Apellido',
  specialtyLabel: 'Especialidad',
  license: 'No. de Exequátur',
  countryLabel: 'Pais',
  providerCode: 'Código de prestador',
  doctorTitle: "Datos del médico prescriptor",
  enterData:"Ingresa los siguientes datos",
  diagnosesTitle: "Diagnóstico(s)",
  productsTitle: "Producto(s)",
  prescriptionTitle: "Receta / Indicación",
  prescriptionDescription: "Archivos en formato PDF, PNG o JPEG, peso máximo 20Mb",
  buttons: {
    add: "Agregar"
  },
  noFiles: "No hay archivos adjuntos",
  sponsorProduct: {
    title: "Información de consulta",
    subtitle: "Indique el tipo de consulta",
    label: "Tipo de consulta"
  },
  validations: {
    prescription: "Ingrese los datos del médico.",
    diagnoses: "Agregue al menos un diagnóstico.",
    treatments: "Agregue al menos un producto.",
    receiptFile: "Agregue el archivo de receta/indicación.",
    requiredField: "Ingrese todos los campos requeridos."
  }
}